import { c as _c } from "react/compiler-runtime";
import { HotelCitiesMainContentPropertiesType } from "@website/accommodation-ui/hotel-cities-main-content";
import { useFetcher, useFetchers } from "@website/fetcher/use-fetcher";
import { useLoginStatus } from "@website/hooks/auth-manager";
import { Button } from "@website/ui/button";
import { useSnackbar } from "@website/ui/snackbar";
import { getOrigin } from "@website/utils/channel/get-origin";
import { isInvalidCheckin, today, tomorrow } from "@website/utils/date-format";
import { isFilled } from "@website/utils/is-filled";
import { MapFilterProperties, useCityFilterState, useFilters } from "@website/widget/filter";
import { HeaderPropertiesType } from "@website/widget/header";
import { TelesalesAppName } from "@website/widget/telesales";
import isEmpty from "lodash-es/isEmpty";
import last from "lodash-es/last";
import map from "lodash-es/map";
import omit from "lodash-es/omit";
import orderBy from "lodash-es/orderBy";
import pick from "lodash-es/pick";
import toString from "lodash-es/toString";
import uniq from "lodash-es/uniq";
import { useRouter } from "next/router";
import { useEffect, useRef, useState } from "react";
import { useVillagesFilter } from "./filter.hook";
import { fetchHotelRateData, fetchHotelReviewData, fetchInstalmentWallet, fetchVillagesData } from "./index.server";
import { handleEventMapSearchClicked } from "./index.tracking";
import { CityPagePropertiesType, reasonsSchema } from "./index.types";
import { useVillaSearch } from "./search.hook";
export const getBannersByType = (data, type: string) => data?.find?.(item => item?.type === type)?.data?.sort?.((a, b) => a?.order - b?.order) || null || [];
export const useCityPage = properties => {
  const $ = _c(162);
  const {
    locationData,
    villagesData,
    hasError,
    smallBanners,
    staticBanners
  } = properties;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [1];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [pages, setPages] = useState(t0);
  const router = useRouter();
  const [updatedModal, setUpdatedModal] = useState(false);
  const timerReference = useRef(null);
  const t1 = properties?.seoData?.pageTitle;
  let t2;
  if ($[1] !== locationData || $[2] !== t1) {
    t2 = {
      locationData,
      seoPageTitle: t1
    };
    $[1] = locationData;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const searchProperties = useVillaSearch(t2);
  const {
    onOpenFilters
  } = useCityFilterState();
  const {
    isLoggedIn
  } = useLoginStatus();
  const selectedHotelId = router.query?.selectedHotelId;
  const {
    enqueue,
    dequeue
  } = useSnackbar();
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = ["instalmentWallet"];
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isLoggedIn) {
    t4 = {
      enabled: isLoggedIn,
      retry: false,
      queryKey: t3,
      queryFn: _temp
    };
    $[5] = isLoggedIn;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    data: instalmentWallet,
    isLoading: isInstallmentWalletLoading,
    isFetching: isInstallmentWalletFetching
  } = useFetcher(t4);
  let t5;
  if ($[7] !== pages || $[8] !== router.query) {
    let t6;
    if ($[10] !== router.query) {
      t6 = page => ({
        queryKey: ["villagesData", omit(router.query, ["modal", "selectedHotelId", "popover", "item"]), page],
        queryFn: () => fetchVillagesData({
          ...router.query,
          page
        })
      });
      $[10] = router.query;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    t5 = pages.map(t6);
    $[7] = pages;
    $[8] = router.query;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[12] !== t5) {
    t6 = {
      queries: t5
    };
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const freshVillagesData = useFetchers(t6);
  let t7;
  if ($[14] !== freshVillagesData) {
    t7 = () => Promise.any(freshVillagesData.map(_temp2)).finally(() => setUpdatedModal(false));
    $[14] = freshVillagesData;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const updateResultSearchHandler = t7;
  let t8;
  if ($[16] !== router) {
    t8 = value => router.push({
      pathname: router.pathname,
      query: {
        ...router.query,
        order_by: value
      }
    }, undefined, {
      shallow: true,
      scroll: false
    });
    $[16] = router;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  const onSortChange = t8;
  let t10;
  let t9;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      timerReference.current = setTimeout(() => setUpdatedModal(true), 900000);
      return () => {
        timerReference.current && clearTimeout(timerReference.current);
      };
    };
    t10 = [];
    $[18] = t10;
    $[19] = t9;
  } else {
    t10 = $[18];
    t9 = $[19];
  }
  useEffect(t9, t10);
  let t11;
  if ($[20] !== router) {
    t11 = () => {
      if (!router.isReady) {
        return;
      }
      const {
        date_from,
        date_to
      } = router.query;
      const shouldRedirect = isInvalidCheckin(date_from, date_to);
      if (shouldRedirect) {
        router.replace({
          pathname: "/[locationType]/[cityTitle]",
          query: {
            locationType: router.query.locationType,
            cityTitle: router.query.cityTitle
          }
        }, undefined, {
          shallow: true,
          scroll: false
        });
      }
    };
    $[20] = router;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== router.isReady || $[23] !== router.query) {
    t12 = [router.isReady, router.query];
    $[22] = router.isReady;
    $[23] = router.query;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  useEffect(t11, t12);
  let t13;
  if ($[25] !== freshVillagesData) {
    t13 = !freshVillagesData?.length || freshVillagesData?.some(_temp3);
    $[25] = freshVillagesData;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  const loading = t13;
  let t14;
  bb0: {
    if (isEmpty(omit(router.query, ["locationType", "cityTitle"])) && loading) {
      t14 = villagesData;
      break bb0;
    }
    t14 = freshVillagesData?.flatMap(_temp4).filter(Boolean) || [];
  }
  const filteredVillages = t14;
  const totalVillagesCount = last(filteredVillages)?.total;
  const citiesFilterProperties = useVillagesFilter(totalVillagesCount, freshVillagesData?.[0]?.isFetched);
  let t15;
  if ($[27] !== citiesFilterProperties.filtersSchema) {
    t15 = {
      schema: citiesFilterProperties.filtersSchema
    };
    $[27] = citiesFilterProperties.filtersSchema;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  const {
    selectedFiltersCount
  } = useFilters(t15);
  const filteredPages = orderBy(uniq(map(filteredVillages, "page")));
  let t16;
  if ($[29] !== locationData?.location) {
    t16 = locationData?.location || {};
    $[29] = locationData?.location;
    $[30] = t16;
  } else {
    t16 = $[30];
  }
  const {
    latitude,
    longitude
  } = t16;
  const coordinate = latitude && longitude ? `${latitude},${longitude},11,33` : null;
  let t17;
  if ($[31] !== coordinate || $[32] !== locationData?.id || $[33] !== locationData?.title || $[34] !== router) {
    const goToMapFilter = () => {
      handleEventMapSearchClicked({
        city: locationData?.title,
        city_id: locationData?.id,
        date_from: toString(router.query?.date_from),
        date_to: toString(router.query?.date_to)
      });
      return router.push({
        pathname: "/map",
        query: {
          ...(coordinate ? {
            coordinate
          } : {}),
          ...omit(router.query, ["locationType", "cityTitle", "viewport_change_type"])
        }
      });
    };
    t17 = {
      label: "\u0645\u0634\u0627\u0647\u062F\u0647 \u0631\u0648\u06CC \u0646\u0642\u0634\u0647",
      onClick: goToMapFilter
    };
    $[31] = coordinate;
    $[32] = locationData?.id;
    $[33] = locationData?.title;
    $[34] = router;
    $[35] = t17;
  } else {
    t17 = $[35];
  }
  const mapFilterProperties = t17;
  const t18 = Boolean(selectedHotelId);
  let t19;
  if ($[36] !== selectedHotelId) {
    t19 = ["hotelRateData", selectedHotelId];
    $[36] = selectedHotelId;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== t18 || $[39] !== t19) {
    t20 = {
      refetchOnMount: true,
      enabled: t18,
      queryKey: t19,
      queryFn: _temp5
    };
    $[38] = t18;
    $[39] = t19;
    $[40] = t20;
  } else {
    t20 = $[40];
  }
  const {
    data: hotelRateData
  } = useFetcher(t20);
  const t21 = Boolean(selectedHotelId);
  let t22;
  if ($[41] !== selectedHotelId) {
    t22 = ["hotelReviewData", selectedHotelId];
    $[41] = selectedHotelId;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t21 || $[44] !== t22) {
    t23 = {
      refetchOnMount: true,
      enabled: t21,
      queryKey: t22,
      queryFn: _temp6
    };
    $[43] = t21;
    $[44] = t22;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  const {
    data: hotelReviewData
  } = useFetcher(t23);
  let t24;
  if ($[46] !== coordinate || $[47] !== router) {
    t24 = () => router?.push({
      pathname: "/map",
      query: {
        ...(coordinate ? {
          coordinate
        } : {}),
        ...omit(router?.query, ["cityTitle", "locationType", "extra_capacity", "modal", "coordinate", "viewport_change_type"])
      }
    }, undefined, {
      shallow: true,
      scroll: false
    });
    $[46] = coordinate;
    $[47] = router;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  const onMapClick = t24;
  let t25;
  if ($[49] !== dequeue || $[50] !== enqueue || $[51] !== router.query || $[52] !== searchProperties.setIsSearchPanelOpen) {
    t25 = () => {
      if (["date_from", "date_to"].every(key => !isFilled(router.query[key]))) {
        const buttonProperties = {
          onClick: () => {
            searchProperties.setIsSearchPanelOpen.bind(null, true)();
            setTimeout(() => {
              dequeue(snackBarId);
            }, 100);
          },
          color: "secondary" as const,
          variant: "text" as const
        };
        const snackBarId = enqueue("\u0628\u0631\u0627\u06CC \u0645\u0634\u0627\u0647\u062F\u0647 \u0642\u06CC\u0645\u062A \u062F\u0642\u06CC\u0642 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647\u200C\u0647\u0627\u066C \u062A\u0627\u0631\u06CC\u062E \u0631\u0627 \u0648\u0627\u0631\u062F \u06A9\u0646\u06CC\u062F.", "default", "one-line", <Button {...buttonProperties}>تکمیل اطلاعات</Button>);
      }
    };
    $[49] = dequeue;
    $[50] = enqueue;
    $[51] = router.query;
    $[52] = searchProperties.setIsSearchPanelOpen;
    $[53] = t25;
  } else {
    t25 = $[53];
  }
  let t26;
  if ($[54] !== dequeue || $[55] !== enqueue || $[56] !== router || $[57] !== searchProperties.setIsSearchPanelOpen) {
    t26 = [router, searchProperties.setIsSearchPanelOpen, enqueue, dequeue];
    $[54] = dequeue;
    $[55] = enqueue;
    $[56] = router;
    $[57] = searchProperties.setIsSearchPanelOpen;
    $[58] = t26;
  } else {
    t26 = $[58];
  }
  useEffect(t25, t26);
  let t27;
  if ($[59] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = {
      title: "\u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647"
    };
    $[59] = t27;
  } else {
    t27 = $[59];
  }
  const t28 = coordinate && mapFilterProperties;
  let t29;
  if ($[60] !== citiesFilterProperties || $[61] !== loading || $[62] !== t28) {
    t29 = {
      ...citiesFilterProperties,
      mapFilterProps: t28,
      loading
    };
    $[60] = citiesFilterProperties;
    $[61] = loading;
    $[62] = t28;
    $[63] = t29;
  } else {
    t29 = $[63];
  }
  let t30;
  if ($[64] !== updateResultSearchHandler || $[65] !== updatedModal) {
    t30 = {
      isOpen: updatedModal,
      onUpdateResult: updateResultSearchHandler
    };
    $[64] = updateResultSearchHandler;
    $[65] = updatedModal;
    $[66] = t30;
  } else {
    t30 = $[66];
  }
  const t31 = citiesFilterProperties.chipsFiltersSchema;
  const t32 = citiesFilterProperties.clearAllFilters;
  const t33 = locationData?.title;
  const t34 = router.query.locationType !== "category";
  const t35 = citiesFilterProperties?.hasNearby;
  let t36;
  if ($[67] !== router.query.order_by) {
    t36 = toString(router.query.order_by);
    $[67] = router.query.order_by;
    $[68] = t36;
  } else {
    t36 = $[68];
  }
  let t37;
  if ($[69] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = [{
      label: "\u0627\u0631\u0632\u0627\u0646\u062A\u0631\u06CC\u0646",
      value: "asc"
    }, {
      label: "\u06AF\u0631\u0627\u0646\u062A\u0631\u06CC\u0646",
      value: "desc"
    }];
    $[69] = t37;
  } else {
    t37 = $[69];
  }
  let t38;
  if ($[70] !== onSortChange || $[71] !== t36) {
    t38 = {
      onChange: onSortChange,
      initialValue: t36,
      list: t37
    };
    $[70] = onSortChange;
    $[71] = t36;
    $[72] = t38;
  } else {
    t38 = $[72];
  }
  let t39;
  if ($[73] !== citiesFilterProperties.chipsFiltersSchema || $[74] !== citiesFilterProperties.clearAllFilters || $[75] !== loading || $[76] !== onOpenFilters || $[77] !== selectedFiltersCount || $[78] !== t33 || $[79] !== t34 || $[80] !== t35 || $[81] !== t38 || $[82] !== totalVillagesCount) {
    t39 = {
      chipsFiltersSchema: t31,
      clearAllFilters: t32,
      loading,
      setFilterOpen: onOpenFilters,
      city: t33,
      totalItem: totalVillagesCount,
      hasCityPrefix: t34,
      hasCityNearby: t35,
      selectedFiltersCount,
      sortProperties: t38
    };
    $[73] = citiesFilterProperties.chipsFiltersSchema;
    $[74] = citiesFilterProperties.clearAllFilters;
    $[75] = loading;
    $[76] = onOpenFilters;
    $[77] = selectedFiltersCount;
    $[78] = t33;
    $[79] = t34;
    $[80] = t35;
    $[81] = t38;
    $[82] = totalVillagesCount;
    $[83] = t39;
  } else {
    t39 = $[83];
  }
  let t40;
  if ($[84] !== filteredPages || $[85] !== loading || $[86] !== totalVillagesCount) {
    t40 = {
      pages: filteredPages,
      setPages,
      loading,
      totalCount: totalVillagesCount
    };
    $[84] = filteredPages;
    $[85] = loading;
    $[86] = totalVillagesCount;
    $[87] = t40;
  } else {
    t40 = $[87];
  }
  const t41 = locationData?.title;
  const t42 = citiesFilterProperties.clearAllFilters;
  const t43 = selectedFiltersCount !== 0;
  const t44 = citiesFilterProperties?.hasNearby;
  const t45 = Number(selectedHotelId);
  let t46;
  if ($[88] !== filteredVillages) {
    t46 = filteredVillages || [];
    $[88] = filteredVillages;
    $[89] = t46;
  } else {
    t46 = $[89];
  }
  let t47;
  if ($[90] !== hotelReviewData?.rateReviews) {
    t47 = hotelReviewData?.rateReviews?.map(_temp7)?.splice(0, 5);
    $[90] = hotelReviewData?.rateReviews;
    $[91] = t47;
  } else {
    t47 = $[91];
  }
  let t48;
  if ($[92] !== hotelRateData || $[93] !== t47) {
    t48 = {
      rate: hotelRateData,
      comments: t47
    };
    $[92] = hotelRateData;
    $[93] = t47;
    $[94] = t48;
  } else {
    t48 = $[94];
  }
  const t49 = t48 as unknown as HotelCitiesMainContentPropertiesType["reviewData"];
  let t50;
  if ($[95] === Symbol.for("react.memo_cache_sentinel")) {
    t50 = [];
    $[95] = t50;
  } else {
    t50 = $[95];
  }
  const t51 = searchProperties.setIsSearchPanelOpen;
  let t52;
  if ($[96] !== staticBanners) {
    t52 = getBannersByType(staticBanners, "static");
    $[96] = staticBanners;
    $[97] = t52;
  } else {
    t52 = $[97];
  }
  const t53 = instalmentWallet?.isEligible;
  const t54 = instalmentWallet?.showDownPayment;
  const t55 = instalmentWallet?.markup;
  const t56 = isInstallmentWalletLoading || isInstallmentWalletFetching;
  let t57;
  if ($[98] !== t53 || $[99] !== t54 || $[100] !== t55 || $[101] !== t56) {
    t57 = {
      isEligible: t53,
      showDownPayment: t54,
      markup: t55,
      isLoading: t56
    };
    $[98] = t53;
    $[99] = t54;
    $[100] = t55;
    $[101] = t56;
    $[102] = t57;
  } else {
    t57 = $[102];
  }
  let t58;
  if ($[103] !== citiesFilterProperties.clearAllFilters || $[104] !== hasError || $[105] !== loading || $[106] !== searchProperties.setIsSearchPanelOpen || $[107] !== t41 || $[108] !== t43 || $[109] !== t44 || $[110] !== t45 || $[111] !== t46 || $[112] !== t49 || $[113] !== t52 || $[114] !== t57 || $[115] !== totalVillagesCount) {
    t58 = {
      size: "small" as const,
      cityTitle: t41,
      clearAllFilters: t42,
      hasError,
      hasFilters: t43,
      hasCityNearby: t44,
      selectedHotelId: t45,
      hotelList: t46,
      reviewData: t49,
      hotelsSuggested: t50,
      loading,
      setIsSearchPanelOpen: t51,
      bannerSlideList: t52,
      totalItem: totalVillagesCount,
      snappPayData: t57
    };
    $[103] = citiesFilterProperties.clearAllFilters;
    $[104] = hasError;
    $[105] = loading;
    $[106] = searchProperties.setIsSearchPanelOpen;
    $[107] = t41;
    $[108] = t43;
    $[109] = t44;
    $[110] = t45;
    $[111] = t46;
    $[112] = t49;
    $[113] = t52;
    $[114] = t57;
    $[115] = totalVillagesCount;
    $[116] = t58;
  } else {
    t58 = $[116];
  }
  let t59;
  if ($[117] === Symbol.for("react.memo_cache_sentinel")) {
    t59 = {
      title: "\u0648\u06CC\u0644\u0627 \u0648 \u0627\u0642\u0627\u0645\u062A\u06AF\u0627\u0647",
      href: `${getOrigin()}/villa`
    };
    $[117] = t59;
  } else {
    t59 = $[117];
  }
  let t60;
  if ($[118] !== locationData?.state?.slug || $[119] !== locationData?.state?.title || $[120] !== router.query) {
    t60 = locationData?.state?.slug ? [{
      title: `ویلاهای استان ${locationData?.state?.title}`,
      href: {
        pathname: "/[locationType]/[cityTitle]",
        query: {
          ...pick(router.query, ["cityTitle", "locationType"]),
          locationType: "state",
          cityTitle: locationData?.state?.slug
        }
      }
    }] : [];
    $[118] = locationData?.state?.slug;
    $[119] = locationData?.state?.title;
    $[120] = router.query;
    $[121] = t60;
  } else {
    t60 = $[121];
  }
  const t61 = router.query.locationType === "category" ? locationData?.title : ` ویلاهای ${locationData?.title}`;
  let t62;
  if ($[122] !== router.query) {
    t62 = pick(router.query, ["cityTitle", "locationType"]);
    $[122] = router.query;
    $[123] = t62;
  } else {
    t62 = $[123];
  }
  let t63;
  if ($[124] !== t62) {
    t63 = {
      pathname: "/[locationType]/[cityTitle]",
      query: t62
    };
    $[124] = t62;
    $[125] = t63;
  } else {
    t63 = $[125];
  }
  let t64;
  if ($[126] !== t61 || $[127] !== t63) {
    t64 = {
      title: t61,
      href: t63
    };
    $[126] = t61;
    $[127] = t63;
    $[128] = t64;
  } else {
    t64 = $[128];
  }
  let t65;
  if ($[129] !== t60 || $[130] !== t64) {
    t65 = {
      color: "default" as const,
      variant: "default" as const,
      list: [t59, ...t60, t64]
    };
    $[129] = t60;
    $[130] = t64;
    $[131] = t65;
  } else {
    t65 = $[131];
  }
  let t66;
  if ($[132] !== router.query.date_from) {
    t66 = router?.query?.date_from || today();
    $[132] = router.query.date_from;
    $[133] = t66;
  } else {
    t66 = $[133];
  }
  let t67;
  if ($[134] !== t66) {
    t67 = toString(t66);
    $[134] = t66;
    $[135] = t67;
  } else {
    t67 = $[135];
  }
  let t68;
  if ($[136] !== router.query.date_to) {
    t68 = router?.query?.date_to || tomorrow();
    $[136] = router.query.date_to;
    $[137] = t68;
  } else {
    t68 = $[137];
  }
  let t69;
  if ($[138] !== t68) {
    t69 = toString(t68);
    $[138] = t68;
    $[139] = t69;
  } else {
    t69 = $[139];
  }
  const t70 = router?.query?.cityTitle;
  let t71;
  if ($[140] !== t70) {
    t71 = toString(t70);
    $[140] = t70;
    $[141] = t71;
  } else {
    t71 = $[141];
  }
  let t72;
  if ($[142] !== t67 || $[143] !== t69 || $[144] !== t71) {
    t72 = {
      description: " \u0628\u0639\u062F \u0627\u0632 \u062B\u0628\u062A \u062F\u0631\u062E\u0648\u0627\u0633\u062A\u060C \u06A9\u0627\u0631\u0634\u0646\u0627\u0633\u0627\u0646 \u0645\u0627 \u062F\u0631 \u0627\u0633\u0631\u0639 \u0648\u0642\u062A \u0628\u0627 \u0634\u0645\u0627 \u062A\u0645\u0627\u0633 \u062E\u0648\u0627\u0647\u0646\u062F \u06AF\u0631\u0641\u062A \u0648 \u0634\u0645\u0627 \u0631\u0627 \u0628\u0631\u0627\u06CC \u0631\u0632\u0631\u0648 \u0648\u06CC\u0644\u0627 \u0631\u0627\u0647\u0646\u0645\u0627\u06CC\u06CC \u062E\u0648\u0627\u0647\u0646\u062F \u06A9\u0631\u062F.",
      reasons: reasonsSchema,
      requestData: {
        app: "villa" as TelesalesAppName,
        checkin: t67,
        checkout: t69,
        city_from: "",
        city_to: t71,
        funnel: "telesales_box"
      },
      storageKey: "villa_submit-tele-sale-reserve",
      className: "!left-6 !right-auto",
      showAnimatedMobileButton: true
    };
    $[142] = t67;
    $[143] = t69;
    $[144] = t71;
    $[145] = t72;
  } else {
    t72 = $[145];
  }
  let t73;
  if ($[146] !== smallBanners) {
    t73 = getBannersByType(smallBanners, "small");
    $[146] = smallBanners;
    $[147] = t73;
  } else {
    t73 = $[147];
  }
  let t74;
  if ($[148] !== t73) {
    t74 = {
      bannerSlideList: t73
    };
    $[148] = t73;
    $[149] = t74;
  } else {
    t74 = $[149];
  }
  const t75 = Boolean(coordinate);
  let t76;
  if ($[150] !== onMapClick || $[151] !== searchProperties || $[152] !== t29 || $[153] !== t30 || $[154] !== t39 || $[155] !== t40 || $[156] !== t58 || $[157] !== t65 || $[158] !== t72 || $[159] !== t74 || $[160] !== t75) {
    t76 = {
      headerProps: t27 as HeaderPropertiesType,
      searchProperties,
      citiesFilterProperties: t29,
      modalProps: t30,
      hotelListHeaderProps: t39,
      hotelPaginationProps: t40,
      hotelCitiesMainContentProps: t58,
      hotelBreadcrumbsProperties: t65,
      telesaleProperties: t72,
      bannersProperties: t74,
      onMapClick,
      hasMap: t75
    };
    $[150] = onMapClick;
    $[151] = searchProperties;
    $[152] = t29;
    $[153] = t30;
    $[154] = t39;
    $[155] = t40;
    $[156] = t58;
    $[157] = t65;
    $[158] = t72;
    $[159] = t74;
    $[160] = t75;
    $[161] = t76;
  } else {
    t76 = $[161];
  }
  return t76;
};
function _temp() {
  return fetchInstalmentWallet();
}
function _temp2(t0) {
  const {
    refetch
  } = t0;
  return refetch();
}
function _temp3(t0) {
  const {
    isFetching,
    status
  } = t0;
  return isFetching || status === "pending";
}
function _temp4(t0) {
  const {
    data
  } = t0;
  return data;
}
function _temp5(t0) {
  const {
    queryKey
  } = t0;
  return fetchHotelRateData(queryKey[1]);
}
function _temp6(t0) {
  const {
    queryKey: queryKey_0
  } = t0;
  return fetchHotelReviewData(queryKey_0[1], 1, "villa", {} as Record<string, string>);
}
function _temp7(comment) {
  return comment;
}